module.exports = __webpack_public_path__ + "static/media/tour-rec-grey.0d85597a.svg";